// counter.ts
import * as company from '../actions/company.actions';
import { Company } from '../models/company';

export interface State {
  isFetching: boolean;
  showCashflow: boolean;
  company: Company;
  error: any;
}

export const initialState: any = {
  isFetching: false,
  showCashflow: false
};

export function reducer(state: State = initialState, action: company.Actions): State {
  switch (action.type) {

    case company.SET_SHOW_CASHFLOW:
      return Object.assign({}, state, { showCashflow: action.payload });
    case company.FETCH_COMPANY:
      if (state.company && state.company.ticker && action.payload != 'state.company.ticker') {
        return Object.assign({}, state, { isFetching: true, company: null, error: false });
      } else {
        return Object.assign({}, state, { isFetching: true, error: false });
      }

    case company.FETCH_COMPANY_SUCCESS:

      return Object.assign({}, state, { isFetching: false, company: action.payload });

    case company.CLEAR:
      return state;

    default:
      return state;
  }
}

export const getCompany = (state: State) => state.company;
export const getShowCashflow = (state: State) => state.showCashflow;



// WEBPACK FOOTER //
// ./src/reducers/company.reducer.ts